









































































































































/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import FormTextInput from '@/components/shared/FormTextInput.vue';
import LayerConfig from '@/models/map-context/LayerConfig';
import { EventBus, EVENTS } from '@/services/EventBus';
import FileSaver from 'file-saver';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Component from 'vue-class-component';
import LegendPlugin from '../legend/LegendPlugin.vue';
import PluginComponent from '../PluginComponent';

@Component({
  props: {
  },
  components: {
    FormTextInput,
    LegendPlugin,
  },
})
export default class PrintPanelPlugin extends PluginComponent {
  static ID='PrintPanelPlugin';

  formats=[{ value: 'PDF', text: 'PDF' }, { value: 'PNG', text: 'PNG' }];

  orientationList = [{ value: 'Portrait', text: 'Portrait' }, { value: 'Paysage', text: 'Paysage' }];

  orientation = 'Paysage';

  paperFormatList = [{ value: 'a5', text: 'A5' },
    { value: 'a4', text: 'A4' },
    { value: 'a3', text: 'A3' },
    { value: 'a2', text: 'A2' },
    { value: 'a1', text: 'A1' },
    { value: 'a0', text: 'A0' },
  ];

  paperFormat = 'a4';

  qualityList = [{ value: 72, text: 'Basse' },
    { value: 150, text: 'Normale' },
    { value: 200, text: 'HD' },
    { value: 300, text: 'Ultra HD' }];

  quality = 150;

  title={ value: '', placeholder: 'Renseignez un titre (optionel)' };

  format={ value: 'PDF' };

  showPrintPreview=false;

  formatdims:any = {
    a0: [1189, 841],
    a1: [841, 594],
    a2: [594, 420],
    a3: [420, 297],
    a4: [297, 210],
    a5: [210, 148],
  };

  scaleValue='';

  scaleDPI:any = {
    a0: 600,
    a1: 600,
    a2: 600,
    a3: 600,
    a4: 110,
    a5: 60,
  };

  rotation=0;

  legend:any;

  addLegend = true;

  logoUrl = null;

  scaleElement:any =null;

  printElement:any =null;

  mainMapElement:any =null;

  mapLoading =false;

  mounted() {
    this.logoUrl = this.contextService.configuration.header.logo;
    this.mainMapElement = this.getOpenLayersMapService().getMapContainer();
    this.printElement = this.getOpenLayersMapService().getPrintContainer();

    const logo = this.plugin.getParameterValue('logo');
    if (logo && logo.length > 0) {
      this.logoUrl = logo;
    }
    this.scaleElement = this.getOpenLayersMapService().getScaleContainer();
    setTimeout(()=>this.updateMap(),500)
    this.getOpenLayersMapService().map.on('rendercomplete', (event:any) => {
      this.mapLoading=false;
    });

    window.addEventListener('resize', this.onResize);
  }

  onResize(){
    let self=this;
    setTimeout( function() { self.updateMap();self.mapLoading = false;}, 200);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.printElement.style.width =  '100%'
    this.printElement.style.height = '100%'
    this.printElement.style['-webkit-transform']='unset';
    this.printElement.style.transform='unset';
    this.printElement.style['pointer-events']="none"
    this.printElement.style['-webkit-box-shadow']='unset';
    this.getOpenLayersMapService().map.setTarget(this.mainMapElement)
    this.scaleElement.style.transform='unset';
    this.scaleElement.style['-webkit-transform']='unset';
  }  

  getMapPrintSize():[number, number]{
    let [w,h]=this.getPagePrintSize();
    // - 50 de marge a droite et à gauche
    // -180 de header et footer
    return [w - 50,h - 180];
  }

  getPagePrintSize():[number, number]{
    
    let dim = this.getPagePrintSizeMm()
    const resolution = this.quality;
    let width = Math.round((dim[0] * resolution) / 25.4) ;
    let height = Math.round((dim[1] * resolution) / 25.4) ;
    return [width,height];
  }
   getPagePrintSizeMm():[number, number]{
    const format = this.paperFormat;
    let dim = this.formatdims[format];
    const resolution = this.quality;
    if (this.orientation === 'Portrait') {
      dim = [...dim].reverse();
    }
   
    return dim;
  }

  updateMap(){
    this.mapLoading = true;
    let currentExtent=this.getOpenLayersMapService().getMapExtent();
    
    //const format = this.paperFormat;
    //this.getOpenLayersMapService().scaleLine.setDpi(this.scaleDPI[format]);
    //this.getOpenLayersMapService().scaleLine.setProperties('minWidth',this.scaleDPI[format]);

    let [width,height]=this.getMapPrintSize();

    var s = this.printElement.parentNode.parentNode.getBoundingClientRect()
    this.printElement.parentNode.style.width = s.width + 'px'
    this.printElement.parentNode.style.height = s.height + 'px';

    this.getOpenLayersMapService().map.setTarget(this.printElement);

    var scx = (s.width - 40) / width;
    var scy = (s.height - 40) / height;
    var sc = Math.min(scx, scy, 1);

    this.printElement.style.width = width + 'px';
    this.printElement.style.height = height + 'px';
    this.printElement.style['pointer-events']="all";
    this.printElement.style.top='50%'
    this.printElement.style.left='50%';
    this.printElement.style.position='absolute';
    this.printElement.style['-webkit-transform'] =
    this.printElement.style.transform = 'translate(-50%,-50%) scale(' + sc + ')';

    const px = Math.round(5 / sc);
    this.printElement.style['-webkit-box-shadow'] =
    this.printElement.style['box-shadow'] = px + 'px ' + px + 'px ' + px + 'px rgba(0,0,0,.6)'
    //printElement.style['padding'] = (this.getMargin() * 96 / 25.4) + 'px'
    
    // Il faut aussi appliquer la transfo sur l'échelle sinon la carte et l'échelle ne sont pas cohérentes
    this.scaleElement.style.transform = 
    this.scaleElement.style['-webkit-transform']= 'scale(' + sc + ')';

    if (this.getOpenLayersMapService().map) {
      this.getOpenLayersMapService().map.updateSize()
      this.getOpenLayersMapService().map.getView().fit(currentExtent);
    }
  }

  onChangePaperFormat(event:any) {
    console.log(event);
    this.paperFormat = event;
    this.updateMap();
  }

  onChangeOrientation(event:any) {
    console.log(event);
    this.orientation = event;
    this.updateMap();
  }

  onChangeQuality(event:any) {
    console.log(event);
    this.quality = event;
    this.updateMap();
  }
  
  changeFileFormat(format:any) {
    this.format = format;
  }

  copyMapCanvas(){
    // la taille de la carte à copier
    // depend de la taille de l'emplacement de la carte dans le template
    let [mapWidth,mapHeight]=this.getMapPrintSize();
    const newCanvas = document.createElement('canvas');
    const mapContext:any = newCanvas.getContext('2d');
    newCanvas.width = mapWidth;
    newCanvas.height = mapHeight;
    newCanvas.style.width = `${mapWidth}`;
    newCanvas.style.height = `${mapHeight}`;

      Array.prototype.forEach.call(
        this.printElement.querySelectorAll('.ol-layers canvas'),
        (canvas) => {
          if (canvas.width > 0) {
            console.log([canvas.width, canvas.height]);
            const { opacity } = canvas.parentNode.style;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const { transform } = canvas.style;
            // Get the transform parameters from the style's transform matrix
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix,
            );
            mapContext.drawImage(canvas, 0, 0);
          }
        },
      );

    // apply the old canvas to the new one
    // context.drawImage(mapcanvas, 0, 0);
    const cmap:any = this.$refs.clonedMap;
    if (cmap != null) {
      cmap.appendChild(newCanvas);
    }
  }
  startQuickPrint() {
    console.log('starting print');
    this.showPrintPreview = true;
    this.scaleElement.style.transform='unset'
    this.scaleElement.style['-webkit-transform']='unset'
    this.rotation = this.getOpenLayersMapService().map.getView().getRotation();
    EventBus.$emit(EVENTS.INFO, 'Impression en cours....');
    this.contextService.loading = true;
    this.scaleValue = this.scaleElement.getElementsByClassName('ol-scale-line-inner')[0].innerHTML;
    this.scaleElement.getElementsByClassName('ol-scale-line-inner')[0].innerHTML="&nbsp;";

    // on a modifié la valeur de showPrintPreview
    // donc on attends que vuejs fasse le rendu du html puis on le déplace dans le body
    // (Avec un z-index négatif pour qu'il ne soit pas visible par l'utilisateur)
    // avant de lancer l'impression
     setTimeout(() => {
      // déplacement du div quickfootprint dans le body
      const newParent = document.body;

      let [width,height]=this.getPagePrintSize();

      // init la taille de la page complète
      const qfp:any = this.$refs.quickfootprint;
      qfp.style.width = `${width}px`;
      qfp.style.height = `${height}px`;
      console.log([width, height]);
      const oldParent:any = this.$refs.showPrintPreviewContainer;
      while (oldParent.childNodes.length > 0) {
        newParent.appendChild(oldParent.childNodes[0]);
      }

      this.printLegend().then(()=>{

         // Copie de la carte
        this.copyMapCanvas();

        // Copie de l'échelle
        const scale:any = this.scaleElement;
        if (scale != null) {
          html2canvas(scale, {
            scale: 1, // Adjusts your resolution
          }).then((canvas) => {
            const img = canvas.toDataURL('image/jpeg', 1);
            const scaleImgelement:any = this.$refs.scalePreviewImg;
            if (scaleImgelement != null) {
              scaleImgelement.src = img;
            }
            /* Pour modifier le rendu et debugger,
              mettre en commentaire la ligne suivante et modifier le z-index de
              quickfootprint pour afficher la prévisualisation html
            */
            this.print();
          });
        } else {
          this.print();
        }
    });

    }, 1000);
  }

  

  getSource() {
    const a = this.getMapService()
      .getOrderedLayerList().reverse()
      .filter((x:LayerConfig) => x.isLayerVisible() && x.Attribution && x.Attribution.Title)
      .map((x) => x.Attribution.Title);
    return Array.from(new Set(a)).join(', ');
  }

  printLegend() {
    const htmlContent:any = this.$refs.quickfootprintLegend;
    const w = htmlContent.offsetWidth;
    const h = htmlContent.offsetHeight;
    console.log([w, h]);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return html2canvas(htmlContent, {
      allowTaint: true,
      useCORS: true,
      scale: 1, // Adjusts your resolution
    }).then((canvas:any) => {
      if (this.format.value === 'PDF') {
        self.legend = {
          size: [w, h],
          img: canvas.toDataURL('image/jpeg', 1),
        };
      }
    });
  }
  pixelToMM(value:number){
    return value*25.4/this.quality;
  }
  print() {
    this.showPrintPreview = false;
    const htmlContent:any = this.$refs.quickfootprintContent;
    const quickfootprintElement:any = this.$refs.quickfootprint;
    let [w,h]=this.getPagePrintSize();
    let [Wmm,Hmm]=this.getPagePrintSizeMm();
    // eslint-disable-next-line new-cap
    const doc = new jsPDF(this.orientation === 'Paysage' ? 'l' : 'p', 'mm', [Wmm, Hmm],true);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    html2canvas(htmlContent, {
      // allowTaint:true,
      scale: 2, // Adjusts your resolution
    }).then((canvas:any) => {
      if (self.format.value === 'PDF') {
        const img = canvas.toDataURL('image/jpeg', 1);
        doc.addImage(img, 'JPEG', 0, 0, Wmm, Hmm);
        if (self.addLegend) {
          console.log('add page', [self.legend.size[0], self.legend.size[1]]);
          if (self.legend.size[1] > self.legend.size[0]) {
            doc.addPage([self.pixelToMM(self.legend.size[0]), self.pixelToMM(self.legend.size[1])], 'p');
          } else {
            doc.addPage([self.pixelToMM(self.legend.size[0]), self.pixelToMM(self.legend.size[1])], 'l');
          }
          doc.addImage(self.legend.img, 'JPEG', 0, 0, self.pixelToMM(self.legend.size[0]), self.pixelToMM(self.legend.size[1]));
        }

        doc.save('print.pdf');
      } else if ((window.navigator as any).msSaveBlob) {
        (window.navigator as any).msSaveBlob(canvas.msToBlob(), 'print.png');
      } else {
        canvas.toBlob((blob:any) => {
          FileSaver.saveAs(blob, 'print.png');
        });
      }

      this.scaleElement.getElementsByClassName('ol-scale-line-inner')[0].innerHTML=this.scaleValue;
      EventBus.$emit(EVENTS.INFO, 'Impression terminée....');
      self.contextService.loading = false;
      document.body.removeChild(quickfootprintElement);
    });
  }
}
